var data = { header:{ text:"#### Warning",
    closeButton:true },
  body:{ text:"Please select only **one** of the proactive tests. If you would like to order our most comprehensive proactive test,\nwe recommend the Invitae Genetic Health Screen.\n\nWould you like to update your order to the Invitae Genetic Health Screen?" },
  buttons:[ { text:"Yes add different test",
      isPrimary:true,
      action:"clearAndAddConcepts" },
    { text:"No keep my current order",
      isPrimary:false,
      action:"keepOrder" } ] };
data.header;
data.body;
data.buttons;

export { data as default };
//# sourceMappingURL=preventive_combined_with_preventive_error.esm.js.map
